import { FC, useState } from "react";

import { SUBMISSION_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { PageTabVariant } from "providers/DocViewProvider";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import { selectFullSubmissionById, selectHasSubmissionsForPageId } from "store/selectors";
import { useQueryParam } from "utils/routing";

interface SubmissionsDifferFromResponsesBannerProps {
  selectedTabVariant?: PageTabVariant;
  pageId: string;
}

export const SubmissionsDifferFromResponsesBanner: FC<
  SubmissionsDifferFromResponsesBannerProps
> = ({ selectedTabVariant, pageId }) => {
  const { canAuthorSection } = useCapabilities();
  const [showBanner, setShowBanner] = useState(true);
  const submissionId = useQueryParam(SUBMISSION_ID_QUERY_PARAM);
  const submission = useAppSelector((s) => selectFullSubmissionById(s, submissionId));

  const hasSubmissions = useAppSelector((s) => selectHasSubmissionsForPageId(s, pageId));

  const isStudentResponsesTab = selectedTabVariant === "responses";

  const showSubmissionsDifferFromResponsesBanner =
    canAuthorSection && isStudentResponsesTab && hasSubmissions && !submission;

  if (!showSubmissionsDifferFromResponsesBanner) {
    return null;
  }

  return showBanner ? (
    <Banner className="mb-2" kind="info" onDismiss={() => setShowBanner(false)}>
      {t("page_detail_view.submissions_differ_from_responses_banner")}
    </Banner>
  ) : null;
};
